/**
 * The data within the users loyalty state
 * @export
 * @class User
 */
export class CustomerLoyaltyState {
    PointsBalance: number;
    WelcomePointsAvailable?: number;
}
